/**
 * Deutsche Mehrzahlbildung für feste, im Client bekannte Substantive — nicht
 * für Serverwerte. `Intl.PluralRules('de-DE')` unterscheidet nur „one" (genau
 * 1) und „other" (alles sonst, auch 0); im Deutschen reicht das für jedes
 * reguläre Substantiv.
 *
 * Ersetzt das kopierte `{count} Posten`-Muster (`features/billing/
 * OpenItemsList.tsx`), das nur zufällig trug, weil „Posten" im Deutschen
 * unverändert bleibt — bei „Klärfälle" ergab dieselbe Kopie „1 Klärfälle"
 * (Spec 04c, Befund K-D1). Aufzählungen, die der Server liefert (`summary`,
 * Enum-Labels), werden dagegen wörtlich übernommen (`design-system`) — diese
 * Funktion ist ausschließlich für feste Client-Beschriftungen wie
 * Zeilenzähler gedacht.
 */

const RULES = new Intl.PluralRules('de-DE')

export function pluralize(count: number, singular: string, plural: string): string {
  return RULES.select(count) === 'one' ? singular : plural
}
